<template>
  <div style="width: 151px;" class="flex items-start items-center" :class="{ 'text-muted': !active, 'text-active': active }">
    <div class="font-bold" style="font-size: 6.5rem; line-height: 1.2;">{{ period.id }}</div>
    <div class="year font-medium transform -rotate-90 -ml-5">{{ period.start_year }}</div>
    <div class="year font-medium transform -rotate-90 -ml-11">{{ period.end_year }}</div>
  </div>
</template>

<script>
export default {
  name: "Period",
  props: {
    period: {
      type: Object,
      require: true
    },
    active: Boolean
  }
}
</script>

<style scoped>
.year {
  font-size: 2.2rem;
  line-height: 4.5rem;
  @apply font-bold;
}
</style>
